export default "__VITE_ASSET__8vy0rBE4__"